import React from "react";


const About = () => {

  return (
    <>

      <div className="about">
        <h2  style={{ color: "#00FFFF" }} >About</h2>
        <>
          <article>
            <p>
              <h2 style={{ color: "#FFFF00" }}>My self</h2>
              Hello,
              My name is "Rutuja Kumthekar" and I am 23 years old.
              I recently graduated from Sharad Institute of technology college of Engineering, Maharashtra with a B.Tech in Computer Science.
            </p>
            <p>
              <h2 style={{ color: "#FFFF00" }}>Work experience</h2>
              I have experience with coding languages HTML,CSS, and Javascript.
              I have learned how to program in java and javascript as well.
              I have a good understanding of React JS and Javascript and I'm also a good learner.
            </p>

            <p>
              Along with my degree as completed a few web development internships in <b style={{ color: "#00FF00" }}>"Tecspeck IT Solution, Sangli(Maharastra)"</b>
              and
             <b  style={{ color: "#00FF00" }}> "Newton School".</b> 
               And the various technology I have learned are helping me develop my current project.
              I have discovered my strengths in logical thinking over the past few years that I enjoy making new web designs and
             play chess.
              I'm always ready to try and learn new things and technology that would help to improve my skills for further growth.
              I have also good web development skills and I've faced a problem working in a team during my internship time period. So I also have good problem-solving skills.
            </p>
            <p>
              <h2 style={{ color: "#FFFF00" }}>why do I want this Job?</h2>
              I want this job because I believe that this organization will provide me with an excellent
              opportunity to learn and grow.
              I want to improve my coding skills and get exposure to projects, challenges, and events that you guys have to offer.
              This can also be helpful in landing my first job.
              I assure you that if I'm given this opportunity, I'll give my 100% and prove to be a great asset to your organization.
              So here I am applying to be one of your developer because the more I think about this idea the more tremendous I think it is I really want to take up this challenge. I'm really looking forward to working with you on the web domain and gaining experience. I hope I'll be granted this opportunity, So try me to try the revolution.
            </p>
            <p style={{ color: "#FF00FF" }} >Thank You Be Safe.</p>
          
          </article>
        </>
      </div>
    </>
  );
};

export default About;
